import * as postsExports from './posts';
import * as commentsExports from './comments';
import * as challengesExports from './challenges';
import * as learningPathsExports from './learningPaths';
import metadata from './metadata';
import * as usersExports from './users';
import * as progressExports from './progress';
import * as reportsExports from './reports';
import * as authExports from './auth';
import * as legalExports from './legal';
import * as certificatesExports from './certificates';
import adminExports from './admin';
import * as notificationsExports from './notifications';

const posts = {
  ...postsExports,
  delete: postsExports.remove
};

const comments = {
  ...commentsExports,
  delete: commentsExports.remove
};

const challenges = {
  ...challengesExports,
  delete: challengesExports.remove
};

const learningPaths = {
  ...learningPathsExports,
  delete: learningPathsExports.remove
};

const users = {
  ...usersExports
};

const progress = {
  ...progressExports
};

const reports = {
  ...reportsExports
};

const auth = {
  ...authExports
};

const legal = {
  ...legalExports,
  delete: legalExports.remove
};

const certificates = {
  ...certificatesExports
};

const admin = {
  ...adminExports
};

const notifications = {
  ...notificationsExports
};

const communityApi = {
  auth,
  posts,
  comments,
  categories: metadata.categories,
  tags: metadata.tags,
  challenges,
  learningPaths,
  users,
  progress,
  reports,
  legal,
  certificates,
  admin,
  notifications
};

export {
  posts,
  comments,
  challenges,
  learningPaths,
  metadata,
  users,
  progress,
  reports,
  auth,
  legal,
  certificates,
  admin,
  notifications
};

export default communityApi;
